var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "design",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36.7 51.3",
    style: {
      enableBackground: "new 0 0 36.7 51.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E44D26;}\r\n\t.st1{fill:#F16529;}\r\n\t.st2{fill:#EBEBEB;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{fill:#264DE4;}\r\n\t.st5{fill:#2965F1;}\r\n\t.st6{fill:#DAB92D;}\r\n\t.st7{fill:#FFD839;}\r\n\t.st8{fill:#53C1DE;}\r\n\t.st9{fill:#002A41;}\r\n\t.st10{fill:#0071B5;}\r\n\t.st11{fill:#DF4F4F;}\r\n\t.st12{fill:#26262C;}\r\n\t.st13{fill:#CCCCCC;}\r\n\t.st14{fill:#A6120D;}\r\n\t.st15{fill:#B3B3B3;}\r\n\t.st16{fill:#DD1B16;}\r\n\t.st17{fill:#F2F2F2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "0.2,9.8 36.6,9.8 33.4,46.9 18.4,51.2 3.3,46.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "18.4,12.8 18.4,48.1 30.5,44.5 33.2,12.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "17.2,17.2 17.2,43.2 8.8,40.6 8.2,33.4 11.8,33.4 12.2,36.9 13.5,37.3 12.8,17.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "19.2,17.2 19.2,31 23.7,31 23.4,37 19.2,38.2 19.2,43.2 27.5,40.7 28.8,26.5 23.9,26.5 23.9,21.9  29.2,21.9 29.8,17.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.4,0 15.4,4.4 14.5,4.4 14.5,4 12.4,4 12.4,6.3 17.5,6.3 17.5,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "18.6,0 24.4,0 24.4,1.6 21.6,1.6 24.5,4.4 24.5,6.3 18.6,6.3 18.6,4.6 21.4,4.6 18.5,1.8  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.c171c1fb1fd6fe89dd3018bbf3c3d386.svg";
export { ForwardRef as ReactComponent };